// ----------------- FETCH USER VOD ACCOUNTS -----------------
export const FETCH_USER_VOD_ACCOUNTS_LOADING =
	'FETCH_USER_VOD_ACCOUNTS_LOADING';
export const FETCH_USER_VOD_ACCOUNTS_SUCCESS =
	'FETCH_USER_VOD_ACCOUNTS_SUCCESS';
export const FETCH_USER_VOD_ACCOUNTS_ERROR = 'FETCH_USER_VOD_ACCOUNTS_ERROR';
